<div class="flex flex-row flex-wrap gap-8">
  <pr-statistic
    label="Eligible Entries"
    tooltip="Entries that are enrolled as eligible to enter the campaign. They will be added to the campaign run in preview status."
  >
    {{ enrolment().estimates.newEntries }}
  </pr-statistic>

  <pr-campaign-run-estimates [estimates]="enrolment().estimates" />

  <pr-statistic
    label="Skipped Entries"
    tooltip="Entries that were found eligible but will be skipped, these entries will not be added to the campaign run. This is usually due to duplicate entries or entries that are not ready for re-entry"
  >
    {{ enrolment().skippedEntries }}
  </pr-statistic>
</div>
